<span class="time-display" [innerHTML]="timeDisplayHtml"></span>
&nbsp;
<span [innerHtml]="'go-recorder-time-remaining-countdown_remaining-text' | translate"></span>
